import { useEffect, useState } from 'react';

interface useFetchingCallbacksProps {
  isFetching: boolean;
  fetchingError: unknown;
  successCallback: () => void;
  errorCallback: (error: unknown) => void;
}

/**
 * Hook that watches fetching and error flags and calls the appropriate callback
 * when the fetching is done or an error occurs.
 * @param param0
 */
export const useFetchingCallbacks = ({
  isFetching,
  fetchingError,
  successCallback,
  errorCallback,
}: useFetchingCallbacksProps) => {
  const [wasFetching, setWasFetching] = useState(isFetching);
  const [hadError, setHadError] = useState(fetchingError !== null);

  useEffect(() => {
    // check if isFetching transitioned from true to false and there was no error
    if (wasFetching && !isFetching && !fetchingError) {
      successCallback();
    }
    setWasFetching(isFetching);
  }, [isFetching, fetchingError]);

  useEffect(() => {
    // check if fetchingVersionSnapshotsError transitioned from null to a value
    if (!hadError && fetchingError) {
      errorCallback(fetchingError);
    }
    setHadError(fetchingError !== null);
  }, [fetchingError]);
};
